export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const PAGINATION = 'rememberPagination'
export const DELETE_HANDLER = 'deleteHandler'
export const DELETE_SINGLE_RECORD_HANDLER = 'deleteSingleRecordHandler'
export const USERS = 'getUsers'
export const PROJECTS = 'getProjects'
export const WORKTYPES = 'getWorktypes'
export const ACTIVITIES = 'getActivities'
export const HOLIDAYS = 'getHolidays'
export const RELOAD_NEW_CONTENT = 'reloadNewContent'
export const GET_RUNNING = 'getRunningTimer'
export const GETCURRENTPROJECTS = 'getCurrentProjects'
